module.exports = __webpack_public_path__ + "img/5.598e1217.png";